import Vue from 'vue'
import store from '../store'
let eventBus = new Vue({
  store,
})

export default eventBus
